import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=27d92658&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=27d92658&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports